import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SearchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"search"}/>
}
